<template>
	<div class="search-dict-data">
		<div class="el-search vue-top-padding radius">
			<div class="el-left">
				<el-button
					type="primary"
					size="small"
					icon="el-icon-plus"
					@click="addDict"
					>{{ $t("common.add") }}</el-button
				>
			</div>
			<div class="el-right">
				<el-form
					ref="dict"
					:model="dict"
					:inline="true"
					label-width="10px"
					size="small"
					class="demo-form-inline el-input-height"
				>
					<el-form-item>
						<el-select
							v-model="dict.codesId"
							filterable
							:no-data-text="$t('common.noData')"
							:no-match-text="$t('common.noData')"
							:placeholder="$t('searchDictData.dictType')"
						>
							<el-option
								v-for="item in dictTypeList"
								:key="item.id"
								:label="item.name"
								:value="item.id"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="label">
						<el-input
							v-model="dict.label"
							:placeholder="$t('searchDictData.dictName')"
							@input="onSubmit"
						></el-input>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" @click="onSubmit" icon="el-icon-search">{{
							$t("common.search")
						}}</el-button>
						<el-button @click="resetSearch('dict')" icon="el-icon-refresh">{{
							$t("common.reset")
						}}</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SearchDictData",
	props: {
		dict: Object,
	},
	data() {
		return {
			dictTypeList: [],
		};
	},
	mounted() {
		this.loadDictType();
	},
	methods: {
		loadDictType() {
			this.$api.request(this.$url.DictType.list, this.$method.get).then(res => {
				if (res.code === 0) {
					this.dictTypeList = res.data;
				}
			});
		},

		addDict() {
			this.$emit("addDict");
		},

		enableSelect(event) {
			this.$emit("enableSelect", event);
		},

		onSubmit() {
			this.$emit("onSubmit", this.dict);
		},

		resetSearch(formName) {
			this.$refs[formName].resetFields(); // 这个只是清除了表单数据，对象并没有重新赋值，所以调用下面的方法赋空值
			let codesId = this.dict.codesId;
			let pageSize = this.dict.pageSize;
			let totalSize = this.dict.totalSize;
			this.$toolUtil.clearForm(this.dict);
			this.dict.codesId = codesId;
			this.dict.pageSize = pageSize;
			this.dict.totalSize = totalSize;
			this.$emit("resetSearch", this.dict);
		},
	},
};
</script>

<style scoped></style>
